let _logger;

module.exports = {
  setLogger: (logger) => {
    _logger = logger;
  },
  logError: (err, attrs) => {
    return _logger?.logError(err, attrs);
  },
};
